import React from 'react';
import { styled } from "../../../stitches.config";
import { observer } from 'mobx-react'
import HtmlParser from '../../../components/Article/Content/HtmlParser'
import { useStores } from '../../../helpers/useStores'

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';


const ParagraphAnimated = observer(({ paragraph, reserved }) => {
    const { text } = paragraph;
    const { ArticleStore } = useStores();
    return (
        <Wrapper>
            {reserved ?
                <AnimationOnScroll duration="3" animateOnce={true} animateIn="animate__fadeInRight">
                    <WrapperPraser>
                        <HtmlParser data={text} disableNofollow={ArticleStore.article.disableNofollowExtra} />
                    </WrapperPraser>
                </AnimationOnScroll>
                :
                <AnimationOnScroll duration="3" animateOnce={true} animateIn="animate__fadeInLeft">
                    <WrapperPraser>
                        <HtmlParser data={text} disableNofollow={ArticleStore.article.disableNofollowExtra} />
                    </WrapperPraser>
                </AnimationOnScroll>
            }
        </Wrapper>
    )
})

const Wrapper = styled("div",{
    margin: "20px 38px",
    color: "$grayscale100Fixed",
    fontSize: "16px",
    fontWeight: "400",
    letterSpacing: 1,
    lineHeight: 26,
    fontFamily: "$charis",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "@bp4":{
        margin: "20px auto",
        fontSize: "21px",
        letterSpacing: 0,
        lineHeight: 32
    },

});

const WrapperPraser = styled("div",{
    "@bp4":{
        width: "840px",
        margin: "0 20px",
        flexShrink: 0
    }
});

export default ParagraphAnimated;